module.exports = __webpack_public_path__ + "static/media/crp-scroll-middle-blank.83b495cd.png";